import React, { useState } from "react";
import { Modal } from "react-responsive-modal";
import { withTranslation, useTranslation } from "react-i18next";
import SignaturePad from "react-signature-canvas";
import CountryPicker from "./CountryPicker";
import NationalityPicker from "./NationalityPicker";
import PhoneCodePicker from "./PhoneCodePicker";
import DateTimePickerComponent from "../components/DateTimePickerComponent";
import Terms from "../components/Terms";
import { get, isEmpty } from "lodash";

const SecondStep = (props) => {
  const { t } = useTranslation();
  const [openSig, setOpenSig] = useState(false);
  const [countryOpen, setCountryOpen] = useState(false);
  const [nationalityOpen, setNationalityOpen] = useState(false);
  const [phoneOpen, setPhoneOpen] = useState(false);
  const ref = React.createRef();

  const onOpenSigModal = () => {
    setOpenSig(true);
  };

  const onCloseSigModal = () => setOpenSig(false);

  const handleOK = () => {
    const returnObj = {
      name: "signature",
      value: {
        uri: ref.current.toDataURL(),
        name: "signature.png",
        type: "image/png",
      },
    };
    props.handleChange({ target: returnObj });
    onCloseSigModal();
  };

  const handleClear = () => {
    ref.current.clear();
  };

  const onOpenCountryModal = () => setCountryOpen(true);
  const onCloseCountryModal = () => {
    setCountryOpen(false);
    resetHtmlStyle();
  };

  const onOpenNationalityModal = () => setNationalityOpen(true);
  const onCloseNationalityModal = () => {
    setNationalityOpen(false);
    resetHtmlStyle();
  };

  const onOpenPhoneModal = () => setPhoneOpen(true);
  const onClosePhoneModal = () => {
    setPhoneOpen(false);
    resetHtmlStyle();
  };
  const resetHtmlStyle = () => {
    const html = document.querySelector("html");
    html.style = "";
  };
  const countryHandler = (value) => {
    if (value) {
      onCloseCountryModal();
      const returnObj = { name: "country", value: value.name };
      props.handleChange({ target: returnObj });
      const returnObjCode = { name: "countryCode", value: value.value };
      props.handleChange({ target: returnObjCode });
      phoneHandler(value);
    }
  };

  const phoneHandler = (value) => {
    if (value) {
      onClosePhoneModal();
      const returnObj = { name: "phoneCode", value: value.phone };
      props.handleChange({ target: returnObj });
    }
  };

  const nationalityHandler = (value) => {
    if (value) {
      onCloseNationalityModal();
      const returnObj = { name: "nationality", value: value.nationality };
      props.handleChange({ target: returnObj });
      const returnObjCode = {
        name: "nationalityCode",
        value: value.alpha_2_code,
      };
      props.handleChange({ target: returnObjCode });
    }
  };

  const customStyles = {
    closeButton: {
      position: "absolute",
      top: "10px",
      right: "10px",
      zIndex: "20",
      outline: "none",
      border: "none",
      width: "30px",
    },
    modal: {
      position: "relative",
      padding: "0",
    },
    overlay: {
      padding: "0",
    },
  };
  const countryClassNames = {
    control: {
      paddingLeft: "0",
    },
    closeButton: "close-button-modal",
    modal: "custom-modal",
    overlay: "overlay-modal",
  };

  const addressOne = get(props.getAddress, "address_one", "");
  const addressTwo = get(props.getAddress, "address_two", "");
  const city = get(props.getAddress, "city_address", "");
  const state = get(props.getAddress, "state_address", "");
  const postalCode = get(props.getAddress, "postcode", "");

  const addressCompleted =
    !isEmpty(addressOne) &&
    (props.interfaceTypeIsHotelKey || !isEmpty(addressTwo)) &&
    !isEmpty(city) &&
    !isEmpty(state) &&
    !isEmpty(postalCode);

  const fullAddress = `${addressOne}${
    props.interfaceTypeIsHotelKey ? "" : `, ${addressTwo}`
  }, ${city}, ${state} ${postalCode}`;

  return (
    <div className="flex flex-col justify-center pt-5">
      <div className="mb-12">
        <p className="type-regular medium">{props.title}</p>
      </div>
      {props.globalError && (
        <div className="mb-8">
          <p className="text-14 text-red-500 pt-6">{props.globalError}</p>
        </div>
      )}
      {props.enableAddressCollection && (
        <>
          <div className="mb-12">
            <p
              className="type-title small"
              style={{
                color: props.backgroundColorTopBar,
              }}>
              {t("ADDRESS").toUpperCase()}
              {props.requiredAddressCollection && (
                <span className="text-gray-400 type-regular small pl-2">
                  {`*${t("REQUIRED")}`}
                </span>
              )}
            </p>
            <div className="md:max-w-2xl text-center mx-auto p-10">
              <button
                className="mb-4 uppercase preCheckinSubTitle font-normal text-16 text-center w-full py-8 border-2 border-dashed rounded-3xl cursor-pointer"
                style={{
                  borderColor: props.backgroundColorTopBar,
                }}
                title={t("ADD_NOW")}
                onClick={() => props.goToAddressCollection()}>
                {!addressCompleted ? (
                  <>
                    <p
                      className=""
                      style={{
                        color: props.backgroundColorTopBar,
                      }}>
                      +
                    </p>
                    <p
                      className="type-title small"
                      style={{
                        color: props.backgroundColorTopBar,
                      }}>
                      {t("ADD_NOW")}
                    </p>
                  </>
                ) : (
                  <p
                    className="type-title small"
                    style={{
                      color: props.backgroundColorTopBar,
                    }}>
                    {fullAddress}
                  </p>
                )}
              </button>
              {addressCompleted && (
                <button
                  className={`mb-4 capitalize type-title small text-16 text-center cursor-pointer underline ${props.buttonStyleName}`}
                  style={{
                    borderColor: props.backgroundColorTopBar,
                  }}
                  title={t("EDIT")}
                  onClick={() => props.goToAddressCollection()}>
                  {t("EDIT")}
                </button>
              )}
            </div>
          </div>
        </>
      )}
      {props.enablePassport && (
        <>
          <div className="flex flex-col mb-12">
            <p
              className="mb-6 type-title small"
              style={{ color: props.backgroundColorTopBar }}>
              {t("COUNTRY").toUpperCase()} /{" "}
              {t("REGION_RESIDENCE").toUpperCase()}
              <span className="text-gray-400 type-regular small pl-2">
                {`*${t("REQUIRED")}`}
              </span>
            </p>
            <p
              className="border-b w-full px-4 py-3 outline-none focus:outline-none type-normal large md:mb-10"
              style={{ borderColor: props.backgroundColorTopBar }}
              onClick={() => onOpenCountryModal()}>
              {props.getCountry}
            </p>
            {props.errors && props.errors["country"] && (
              <p className="text-14 text-red-500">
                {props.errors["country"].join(". ")}
              </p>
            )}
          </div>

          <div className="flex flex-col mb-12">
            <p
              className="mb-6 type-title small"
              style={{ color: props.backgroundColorTopBar }}>
              {t("NATIONALITY").toUpperCase()}
              <span className="text-gray-400 type-regular small pl-2">
                {`*${t("REQUIRED")}`}
              </span>
            </p>
            <p
              className="border-b w-full px-4 py-3 outline-none focus:outline-none type-normal large md:mb-10"
              style={{ borderColor: props.backgroundColorTopBar }}
              onClick={onOpenNationalityModal}>
              {props.getNationality}
            </p>
            {props.errors && props.errors["nationality"] && (
              <p className="text-14 text-red-500">
                {props.errors["nationality"].join(". ")}
              </p>
            )}
          </div>
        </>
      )}
      <div className="flex flex-col mb-12">
        <p
          className="mb-6 type-title small"
          style={{ color: props.backgroundColorTopBar }}>
          {t("PHONE_NUMBER").toUpperCase()}
          {props.phoneRequired && (
            <span className="text-gray-400 type-regular small pl-2">
              {`*${t("REQUIRED")}`}
            </span>
          )}
        </p>
        <div className="flex space-x-4 h-14 mb-4">
          <div className="w-8 flex items-center justify-center">
            <span className="type-normal large">+</span>
          </div>
          <div className="w-16">
            <p
              className="text-center w-full px-4 py-3 outline-none focus:outline-none type-normal large h-full flex items-center justify-center"
              style={{ backgroundColor: "#DBDBDB" }}
              onClick={onOpenPhoneModal}>
              {props.getPhoneCode}
            </p>
          </div>
          <div className="flex-1 flex items-end">
            <input
              type="number"
              name="phone"
              value={props.getPhone}
              onChange={props.handleChange}
              className="border-b w-full appearance-none px-4 outline-none focus:outline-none type-normal large"
              style={{ borderColor: props.backgroundColorTopBar }}
            />
          </div>
        </div>
        {props.phoneRequired && props.errors && props.errors["phone"] && (
          <p className="text-14 text-red-500">
            {props.errors["phone"].join(". ")}
          </p>
        )}
      </div>
      {props.enableDateOfBirth && (
        <div className="flex flex-col mb-12">
          <p
            className="mb-6 type-title small"
            style={{ color: props.backgroundColorTopBar }}>
            {t("DATE_OF_BIRTH").toUpperCase()}
            <span className="text-gray-400 type-regular small pl-2">
              {props.requiredDateOfBirth && `*${t("REQUIRED")}`}
            </span>
          </p>
          <DateTimePickerComponent
            allowBlank
            modalTitle={t("SELECT_BIRTHDAY")}
            getDate={props.getBirthday}
            dateName="birthday"
            format={"DD / MM / YYYY"}
            primaryColor={props.backgroundColorTopBar}
            borderColor={props.backgroundColorTopBar}
            appHomeTextCallToAction={props.appHomeTextCallToAction}
            buttonStyleName={props.buttonStyleName}
            handleChange={props.handleChange}
            className="type-normal large"
          />
          {props.requiredDateOfBirth &&
            props.errors &&
            props.errors["birthday"] && (
              <p className="text-14 text-red-500 pt-4">
                {props.errors["birthday"].join(". ")}
              </p>
            )}
        </div>
      )}
      {props.combination && props.enableSignature && (
        <>
          <div className="flex flex-col mb-14">
            <p className="preCheckinSubTitle font-semibold text-16 text-okkami-husk mb-6 bg-okkami-mercury px-4 py-6 text-okkami-dove-gray">
              {t("SIGNATURE")}
              <span className="text-gray-400 type-regular small pl-2">
                {props.requiredSignature && `*${t("REQUIRED")}`}
              </span>
            </p>
            <div
              onClick={() => onOpenSigModal()}
              className="cursor-pointer border rounded-2xl max-md-lg h-40 flex px-4 items-center ustify-center">
              {!props.getSignature && (
                <div className="preCheckinTitle text-14 cursor-pointer text-okkami-dove-gray3 flex px-4 mx-auto space-x-4">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-6 w-6"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor">
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                    />
                  </svg>
                  <p className="flex items-center text-center">
                    {t("PLEASE_SIGN_HERE", "Please Sign Here.")}
                  </p>
                </div>
              )}
              {props.getSignature && (
                <img
                  src={props.getSignature.uri}
                  alt={t("SIGNATURE")}
                  className="mx-auto h-full"
                  onClick={() => onOpenSigModal()}
                />
              )}
            </div>
            {props.requiredSignature &&
              props.errors &&
              props.errors["signature"] && (
                <p className="text-14 text-red-500 my-4">
                  {props.errors["signature"].join(". ")}
                </p>
              )}
          </div>
          <Modal
            open={openSig}
            onClose={onCloseSigModal}
            center
            blockScroll={true}
            styles={customStyles}>
            <div className="relative">
              <h2 className="py-6 text-center text-16 text-open-sans bg-white w-full bg-white border-b">
                {t("PLEASE_DRAW_YOUR_SIGNATURE")}
              </h2>
              <div className="text-14 text-open-sans leading-8 max-h-full overflow-y-auto relative p-6">
                <SignaturePad
                  penColor="black"
                  ref={ref}
                  confirmText="Save"
                  imageType={"image/svg+xml"}
                  canvasProps={{
                    width: 360,
                    height: 300,
                    className: "sigCanvas border",
                  }}
                />
                <div className="flex space-x-6 pt-4 justify-between">
                  <button
                    onClick={handleClear}
                    className={`px-4 p-6 bg-blue-500 text-white text-14 outline-none ${props.buttonStyleName}`}>
                    {t("CLEAR")}
                  </button>
                  <button
                    onClick={handleOK}
                    className={`px-4 p-6 bg-blue-500 text-white text-14 ${props.buttonStyleName}`}>
                    {t("CONFIRM")}
                  </button>
                </div>
              </div>
            </div>
          </Modal>
        </>
      )}
      <div className="flex flex-col mb-12">
        {!props.enableStripe && (
          <Terms
            title={props.title}
            titleColor={props.titleColor}
            subtitleColor={props.subtitleColor}
            appHomeTextCallToAction={props.appHomeTextCallToAction}
            allTerms={props.allTerms}
            terms={props.terms}
            errors={props.errors}
            handleChange={props.handleChange}
            globalError={props.globalError}
            property={props.property}
          />
        )}
        {props.enablePassport && (
          <>
            <Modal
              open={countryOpen}
              onClose={onCloseCountryModal}
              center
              blockScroll={true}
              classNames={countryClassNames}>
              <div className="relative">
                <CountryPicker
                  countryHandler={countryHandler}
                  getCountry={props.getCountry}
                  styles={{ color: props.backgroundColorTopBar }}
                />
              </div>
            </Modal>
            <Modal
              open={nationalityOpen}
              onClose={onCloseNationalityModal}
              center
              blockScroll={true}
              classNames={countryClassNames}>
              <div className="relative">
                <NationalityPicker
                  nationalityHandler={nationalityHandler}
                  getNationality={props.getNationality}
                  styles={{ color: props.backgroundColorTopBar }}
                />
              </div>
            </Modal>
          </>
        )}

        <Modal
          open={phoneOpen}
          onClose={onClosePhoneModal}
          center
          blockScroll={true}
          classNames={countryClassNames}>
          <div className="relative">
            <PhoneCodePicker
              countryHandler={phoneHandler}
              getPhoneCode={props.getPhoneCode}
              styles={{ color: props.backgroundColorTopBar }}
            />
          </div>
        </Modal>
      </div>
    </div>
  );
};

export default withTranslation()(SecondStep);
